/**
 * Popup display rules (where the age gate shows). Template path: popup.displayCriteria.
 * Modes: all_pages | home | collections | products | product_tags | custom.
 * Storefront: `collections` matches only collection listing URLs (/collections/{handle}), not product pages.
 * Legacy: mode "urls" → "custom".
 */

export const DISPLAY_CRITERIA_MODE_CHOICES = [
  { label: "All pages", value: "all_pages" },
  { label: "Home page", value: "home" },
  { label: "Specific collections", value: "collections" },
  { label: "Specific products", value: "products" },
  { label: "Specific product tags", value: "product_tags" },
  { label: "Custom", value: "custom" },
];

/** Who sees the age gate (storefront script should enforce). */
export const TRIGGER_CONDITION_CHOICES = [
  { label: "Always show", value: "always" },
  { label: "Logged customer", value: "logged_customer" },
];

function splitHandles(s) {
  return String(s || "")
    .split(/[,\n]+/)
    .map((x) => x.trim())
    .filter(Boolean);
}

/** Merge saved JSON into a stable editor shape. */
export function normalizeDisplayCriteria(raw) {
  const base = {
    mode: "all_pages",
    triggerCondition: "always",
    urls: [],
    productTags: "",
    productHandles: "",
    collectionHandles: "",
    selectedProducts: [],
    selectedCollections: [],
  };
  const dc = { ...base, ...(raw && typeof raw === "object" ? raw : {}) };

  dc.triggerCondition =
    dc.triggerCondition === "logged_customer" ? "logged_customer" : "always";

  let mode = dc.mode || "all_pages";
  if (mode === "urls") mode = "custom";
  dc.mode = mode;

  dc.urls = Array.isArray(dc.urls) ? [...dc.urls] : [];
  dc.selectedProducts = Array.isArray(dc.selectedProducts) ? [...dc.selectedProducts] : [];
  dc.selectedCollections = Array.isArray(dc.selectedCollections) ? [...dc.selectedCollections] : [];

  if (dc.mode === "products" && dc.selectedProducts.length === 0 && dc.productHandles) {
    dc.selectedProducts = splitHandles(dc.productHandles).map((handle) => ({ handle }));
  }
  if (dc.mode === "collections" && dc.selectedCollections.length === 0 && dc.collectionHandles) {
    dc.selectedCollections = splitHandles(dc.collectionHandles).map((handle) => ({ handle }));
  }

  return dc;
}
